import React, { useRef } from 'react'
import styled from 'styled-components'

import TextButton from 'components/Luxkit/Button/TextButton'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import useToggle from 'hooks/useToggle'
import { mediaQueryUp } from 'components/utils/breakpoint'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import useExperiencesSortOptions from '../hooks/useExperiencesSortOptions'
import ExperiencesSortByOptions from './ExperiencesSortByOptions'

const DesktopChevron = styled(DropdownChevron)`
  display: none;

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

const SortMenuDesktop = styled(Dropdown)`
  display: none;

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

function ExperienceSearchPageSort() {
  const [open, toggleSort, _, closeSort] = useToggle()
  const triggerRef = useRef<HTMLButtonElement>()
  const { sortBy, sortOptions } = useExperiencesSortOptions()

  return (
    <>
      <TextButton
        kind="secondary"
        variant="dark"
        onClick={toggleSort}
        endIcon={<DesktopChevron open={open}/>}
        ref={triggerRef}
      >
        Sort: {sortOptions[sortBy].label}
      </TextButton>
      <SortMenuDesktop
        open={open}
        onClose={closeSort}
        triggerRef={triggerRef}
        data-testid="sort-options-dropdown"
      >
        <DropdownContainer fit="auto">
          <ExperiencesSortByOptions />
        </DropdownContainer>
      </SortMenuDesktop>
    </>
  )
}

export default ExperienceSearchPageSort
